import { render } from "./vtoolsedit.vue?vue&type=template&id=5477839f"
import script from "./vtoolsedit.vue?vue&type=script&lang=js"
export * from "./vtoolsedit.vue?vue&type=script&lang=js"

import "./vtoolsedit.vue?vue&type=style&index=0&id=5477839f&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__